// extracted by mini-css-extract-plugin
module.exports = {"page-section":"page-section__2tN1A","page-body-wrapper":"page-body-wrapper__1_TOw","title-wrapper":"title-wrapper__2FzBh"};